import React from 'react';

import { TopImpactStoryBubble } from '#src/app/pages/homepage/shared/components';

import { useTopImpactStoriesDesktop } from './hooks/useTopImpactStoriesDesktop';

export const TopImpactStoriesDesktop: React.FC = () => {
	const {
		data: { desktopStories },
		actions: { trackStoryClick },
	} = useTopImpactStoriesDesktop();

	return (
		<div className="hidden grid-cols-5 lg:mt-16 lg:grid xl:mt-30" data-testid="top-impact-stories-container">
			{desktopStories.map((story) => (
				<TopImpactStoryBubble key={story.key} story={story} trackStoryClick={trackStoryClick} />
			))}
		</div>
	);
};
